import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { UserOutlined } from '@ant-design/icons';

// DS
import { Col, Row, VertTypography, VertIcon } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/CheckoutPersonalDataStyles.less';
import { allPropertiesEmpty } from 'Utils/allPropertiesEmpty';
import { Link } from 'react-router-dom';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import isFakeEmail from "Utils/isFakeEmail"
import ynToBool from 'Utils/ynToBool';


// CHECKOUT PERSONAL DATA COMPONENT
const CheckoutPersonalData = ({ ...props }) => {
  const {
    name,
    document,
    email,
    phone,
    setHasInfosAlert,
    personType,
    ie,
    partnerCpf,
  } = props;


  const customPhone =  phone?.includes('undefined') ? '-' : phone;
  const fakeEmail = (ynToBool(process.env.REACT_APP_HIDE_FAKE_EMAIL) && isFakeEmail(email)) ?
    { display: 'none' } : {};


  const isCompany = useCallback(() => {
    if (personType !== 1 && personType !== 'INDIVIDUAL') return true;
    return false;
  }, [personType]);

  if (!allPropertiesEmpty(props)) {
    return (
      <Col className="checkout-personal-data-wrapper col-12 col-md-auto">
        <Col className="checkout-personal-data-title">
          <VertIcon component={UserOutlined} />
          <VertTypography.Title>
            {!isCompany() ? 'Dados pessoais' : 'Meus Dados'}
          </VertTypography.Title>
        </Col>

        <Col className="checkout-personal-data-content">
          <VertTypography.Paragraph>{name}</VertTypography.Paragraph>
          <VertTypography.Paragraph>
            {!isCompany() ? 'CPF: ' : 'CNPJ: '}
            <span>
              {cpf.isValid(document)
                ? cpf.format(document)
                : cnpj.format(document)}
            </span>
          </VertTypography.Paragraph>

          {(() => {
            if (!isCompany() || !ie) return null;
            return (
              <VertTypography.Paragraph>
                {'Inscrição estadual'}: <span>{ie}</span>
              </VertTypography.Paragraph>
            );
          })()}

          {(() => {
            if (!isCompany() || !partnerCpf) return null;
            return (
              <VertTypography.Paragraph>
                {'CPF do sócio'}: <span>{partnerCpf}</span>
              </VertTypography.Paragraph>
            );
          })()}

          <p style={fakeEmail}>
            <VertTypography.Paragraph>
              {' '}
              E-mail: <span>{email}</span>
            </VertTypography.Paragraph>
          </p>
          <VertTypography.Paragraph>
            Contato: <span>{customPhone || '-'}</span>
          </VertTypography.Paragraph>

         
        </Col>
      </Col>
    );
  } else {
    setHasInfosAlert(true);
  }
  return (
    <Col className="checkout-personal-data-wrapper col-12 col-md-auto">
      <Col className="checkout-personal-data-title">
        <VertIcon component={UserOutlined} />
        <VertTypography.Title>Dados pessoais</VertTypography.Title>
      </Col>

      <Col className="checkout-personal-data-content">
        <VertTypography.Paragraph>
          Seus dados não estão cadastrados!
        </VertTypography.Paragraph>
        <VertTypography.Paragraph>
          Por favor, conclua seu cadastro em{' '}
          <Link to={'/profile'}>minhas informações</Link>.
        </VertTypography.Paragraph>
      </Col>
    </Col>
  );
};

CheckoutPersonalData.propTypes = {
  name: PropTypes.string,
  document: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  setHasInfosAlert: PropTypes.func,
  personType: PropTypes.number,
  ie: PropTypes.string,
  partnerCpf: PropTypes.string,
};

export default CheckoutPersonalData;
